const products = [
  { id: 1, name: "Shoes", price: 1200, img: "./images/shoes1.webp" },
  { id: 2, name: "T-Shirt", price: 500, img: "./images/tshirt1.webp" },
  { id: 3, name: "Watch", price: 2000, img: "./images/watch.webp" },
  { id: 4, name: "jeans", price: 700, img: "./images/jeans1.jpg"},
  { id: 5, name: "Hoodie", price: 1000, img: "./images/Hoodie.png"},
  { id: 6, name: "blazer", price: 2500, img: "./images/blazer.avif"},
];

export default products;